// extracted by mini-css-extract-plugin
export default {"mb24":"reportAProblemDone_mb24__kbT5U","mt8":"reportAProblemDone_mt8__BtHDW","modalContent":"reportAProblemDone_modalContent__3wahZ"};